import { Button, Modal } from "materia"
import { useTranslation } from "react-i18next"
import s from "./GroupConfirm.module.scss"

type GroupConfirmProps = {
  title: string
  body: string
  confirmLabel: string
  onConfirm: () => void
  onCancel: () => void
}

/** The stop before archiving or leaving a group. */
export function GroupConfirm({
  title,
  body,
  confirmLabel,
  onConfirm,
  onCancel,
}: GroupConfirmProps) {
  const { t } = useTranslation()

  return (
    <Modal ariaLabel={title} onClose={onCancel}>
      <div className={s.confirm}>
        <h2 className={s.confirm__title}>{title}</h2>
        <p className={s.confirm__body}>{body}</p>

        <div className={s.confirm__actions}>
          <Button theme="delete" borderRadius="24" onClick={onConfirm}>
            {confirmLabel}
          </Button>
          <Button theme="cancel" borderRadius="24" onClick={onCancel}>
            {t("actions.CANCEL")}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
